import RcRange from 'rc-slider/lib/Range';
import styled from 'styled-components';

export const Range = styled(RcRange)`
  && {
    background-color: ${props => props.disabled && 'transparent'};
    width: 95%;
    margin: 0 auto;

    & .rc-slider-rail {
      background-color: ${props => props.theme.carvana.gray.light};
    }
    & .rc-slider-handle {
      background: #fff;
      border-width: 3px;
      box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.24);
    }
  }
`;

export const RangeHeader = styled.div.attrs({ 'data-qa': 'range-header' })`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin-bottom: 20px;

  .title {
    font-size: 14px;
    font-weight: normal;
    line-height: 18px;
  }
  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    .title {
      font-size: 14px;
      font-weight: bold;
      line-height: 20px;
      text-transform: uppercase;
    }
  }
`;

export const RangeLabels = styled.div`
  color: ${props => props.theme.carvana.gray.dark};
  font-size: 12px;
  line-height: 17px;
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
`;

export const Wrapper = styled.div`
  margin: 34px auto 26px;
  max-width: 83%;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    margin: 16px 0 40px;
    max-width: 100%;
    padding: 1rem 0;
  }
`;

export const InputsWrapper = styled.div.attrs({ 'data-qa': 'inputs-wrapper' })`
  margin-top: -6px;
`;
